import React, { useState } from "react" 
import { useParams, useSearchParams } from "react-router-dom"
import _ from "lodash"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, randoms } from "lib/utils"

export default function useDispute({ saveFn }:{ saveFn?:any }) {

  const { dspid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams() 

  const { store, AppStore }:any = appStore()
  const { update }:any = AppStore 

  const [ reloadTemplate, setReloadTemplate ] = useState(false)

  const getPresets = (dispute:any) => {
    return dispute.settings.presets
  }

  const addPreset = (dispute:any, preset:any) => {
    const refstr = randoms.string(12)
    let disputeClone = _.cloneDeep(dispute)
    const presets = getPresets(disputeClone)
    presets.push({...preset, refstr})
    disputeClone.settings.presets = presets
    saveFn.mutate({ resource: "dispute", data: disputeClone })
  }

  const removePreset = (dispute:any, refstr:string) => {
    let disputeClone = _.cloneDeep(dispute)
    const presets = getPresets(disputeClone)
    const updatedPresets = presets.filter( (preset:any) => preset.refstr !== refstr )
    disputeClone.settings.presets = updatedPresets
    saveFn.mutate({ resource: "dispute", data: disputeClone })
  }

  const getElement = (dispute:any, elemtype:string) => {
    const elem = dispute.elements.find( (elem:any) => elem.refstr === elemtype )
    return _.cloneDeep(elem)
  }

  const getElementSettings = (dispute:any, elemtype:string) => {
    const settings = getElement(dispute, elemtype).settings
    return _.cloneDeep(settings)
  }

  const getElementConfig = (dispute:any, elemtype:string) => {
    const config = getElementSettings(dispute, elemtype).config
    return _.cloneDeep(config)
  }

  const replaceElement = (dispute:any, elemtype:string, newElement:any) => {
    let disputeClone = _.cloneDeep(dispute)
    const newElements = disputeClone.elements.map( (elem:any) => {
      if( elem.refstr === elemtype ){
        return newElement 
      }
      return elem
    })
    disputeClone.elements = newElements
    saveFn.mutate({ resource: "dispute", data: disputeClone })
  }

  const replaceElementSettings = (dispute:any, elemtype:string, newSettings:any) => {
    let elem = getElement(dispute, elemtype)
    elem = { ...elem, settings: newSettings }
    replaceElement(dispute, elemtype, elem)
  }

  const replaceElementConfig = (dispute:any, elemtype:string, newConfig:any) => {
    let settings = getElementSettings(dispute, elemtype)
    settings = { ...settings, config: newConfig }
    replaceElementSettings(dispute, elemtype, settings)
  }


  return {
    addPreset,
    removePreset,
    getPresets,
    replaceElement,
    replaceElementSettings,
    replaceElementConfig,
  }
}